/* eslint-disable camelcase */
import React, { useMemo } from 'react';
import { LinksGroupSection } from 'views/rebranded-module/GeoViewV2/components';
import { Box } from '@mui/material';
import PATHS from 'lib/navigation/paths';
import { PLACE_TYPES } from 'views/GeoView/utils/constants';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';

const { AIRPORT, REGION, GEOGRAPHY } = PLACE_TYPES;

const NearbyRentalsWrapper = (props:any) => {
  const { nearbyRentals, handleNearByLinkClick } = props;
  const cmsData = useContent('GeoPage');
  const getInOrNear = (placeType:any) => ([PLACE_TYPES.AIRPORT, PLACE_TYPES.GEOGRAPHY, PLACE_TYPES.zipcode].includes(
    placeType,
  )
    ? 'near'
    : 'in');
  const similarRentalsIn = (modelFirstTypeName, name) => {
    if (name) {
      return interpolateString(
        cmsData.similarRentalsInLabel,{
          name,
          modelFirstTypeName,
      });
    }
    return interpolateString(
      cmsData.similarRentalsLabel,{
        modelFirstTypeName,
    });
  };

  const rentalsInByVehicleModelTitle = (typeOrMakeName, name) => {
    if (name) {
      return interpolateString(
        cmsData.rentalsByVehicleModelInLabel,{
          placeName: '',
          typeOrMakeName,
          name,
      });
    }
    return interpolateString(
      cmsData.rentalsByVehicleModelLabel,{
       typeOrMakeName,
    });
  };

  const rentalsLabel = (rentalsName:string, name:string, type:string) => {
    if (name) {
     
      return getInOrNear(type) === 'near'
        ? 
         interpolateString(
            cmsData.rentalsNameNearLabel, {
              rentalsName,
              name,
            }
          )
        : interpolateString(
            cmsData.rentalsNameInLabel, {
              rentalsName,
              name,
            }
          );
       
    }
    return interpolateString(
      cmsData.rentalsNameLabel,{
        rentalsName,
    });
  };

  const prepareCountriesLinks = (countriesData) => {
    const rentalsName = countriesData.vehicle_type?.name || countriesData.vehicle_make?.name;
    const rentalsSlug = countriesData.vehicle_type?.slug || countriesData.vehicle_make?.slug;
    const title = interpolateString(
      cmsData.rentalsByCountryLabel,{
        rentalsName,
    });
    const linksList = countriesData?.countries.map((country, index) => ({
      id: index,
      path: PATHS.geoSlug([rentalsSlug, country.slug]),
      lable: rentalsLabel(rentalsName, country.name, null),
    }));
    return {
      title,
      linksList,
    };
  };
  const getPlaceData = (spreadedPlaceData) => {
    
    let place;
    const {
      country, region, geography, airport,
    } = spreadedPlaceData;
    const places = {
      country,
      region,
      geography,
      airport,
    };
    Object.entries(places).forEach(([key, value]) => {
      if (value) {
        place = {
          ...value,
          type: key,
        };
      }
    });
    return place;
  };
  const toCamelCase = (str) =>
  str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

  const prepareVehicleTypeOrMakeLinks = (vehicleTypesData, filterType) => {
    const place = getPlaceData(vehicleTypesData);
    const filterTypeLabel = `${toCamelCase(filterType)}Label`;
    const title = 
      getInOrNear(place?.type) === 'near' ?
      interpolateString(
        cmsData.rentalsNearNameByLabel,{
          name: place?.name || '',
          type: interpolateString(
            cmsData[filterTypeLabel],
          ),
      })
    :
      interpolateString(
        cmsData.rentalsInNameByLabel,{
          name: place?.name || ' ',
          type: interpolateString(
              cmsData[filterTypeLabel],
          ),
      });
   
   
    const linksList = vehicleTypesData[`${filterType}s`].map(
      (filter, index) => ({
        id: index,
        path: PATHS.geoSlug([filter.slug, place?.slug]),
        lable: rentalsLabel(filter.name, place?.name, place?.type),
      }),
    );
    return {
      title,
      linksList,
    };
  };
  const prepareVehileModelLinks = (vehicleModelsData) => {
    let title;
    const place = getPlaceData(vehicleModelsData);
    const {
      model_first_type_name,
      vehicle_model,
      vehicle_make,
      vehicle_type,
      vehicle_models,
    } = vehicleModelsData;
    const typeOrMakeName = vehicle_make?.name || vehicle_type?.name;

    if (model_first_type_name) {
      title = similarRentalsIn(model_first_type_name, place?.name);
    } else if (vehicle_model) {
      title = similarRentalsIn(
        vehicle_model.first_vehicle_type.name,
        place?.name,
      );
    } else if ([GEOGRAPHY, AIRPORT].includes(place?.type)) {
      title = rentalsInByVehicleModelTitle(typeOrMakeName, place?.name);
    } else if (typeOrMakeName) {
      title = interpolateString(
        cmsData.rentalsByVehicleModelLabel,{
          placeName: place?.name || '',
          typeOrMakeName,
      });
    }


    const linksList = vehicle_models.map((vehicleModel, index) => ({
      id: index,
      path: PATHS.geoSlug([
        vehicleModel.vehicle_make.slug,
        vehicleModel.slug,
        place?.slug,
      ]),
      lable: rentalsLabel(vehicleModel.name, place?.name, place?.type),
    }));
    return {
      title,
      linksList,
    };
  };

  const prepareGeographyLinks = (geographiesData) => {
    let title;
    const place = getPlaceData(geographiesData);

    const {
      vehicle_model, vehicle_make, vehicle_type, geographies,
    } = geographiesData;
    const modelOrMakeOrTypeName = (
      vehicle_model
      || vehicle_make
      || vehicle_type
    )?.name;
    switch (place?.type) {
      case REGION:
        title= interpolateString(
          cmsData.rentalsByCityLabel,{
            placeName: place?.name || '',
            modelOrMakeOrTypeName,
        });
        break;
      default:
        title = interpolateString(
          cmsData.rentalsNearbyPlaceLabel,{
            placeName: place?.name || '',
            modelOrMakeOrTypeName,
        });
        break;
    }
    const getLabel = (geography) => {
      if (place && !(vehicle_make || vehicle_model || vehicle_type)) {
        return getInOrNear(place?.type) === 'near' ?
        interpolateString(
          cmsData.allRentalsNearGeographyLabel,{
            geography: geography.name,
        }) : interpolateString(
           cmsData.allRentalsInGeographyLabel,{
            geography: geography.name,
        }) ;
      }
      return rentalsLabel(modelOrMakeOrTypeName, geography.name, 'geography');
    };
    const linksList = geographies.map((geography, index) => ({
      id: index,
      path: PATHS.geoSlug([
        vehicle_make?.slug,
        vehicle_type?.slug,
        vehicle_model?.slug,
        geography?.slug,
      ]),
      lable: getLabel(geography),
    }));
    return {
      title,
      linksList,
    };
  };

  const prepareRegionsLinks = (regionsData) => {
    let title;
    const {
      regions,
      geographies,
      vehicle_type,
      vehicle_make,
      vehicle_model,
      country,
    } = regionsData;
    const modelOrMakeOrTypeName = (
      vehicle_model
      || vehicle_make
      || vehicle_type
    )?.name;

    let linksList = [];

    const getLabel = (geography) => {
      if (country && !(vehicle_make || vehicle_model || vehicle_type)) {
        return interpolateString(
          cmsData.allRentalsInGeographyLabel,{
            geography: geography.name,
        });
      }
      return rentalsLabel(modelOrMakeOrTypeName, geography.name, null);
    };
    if (regions?.length > 0) {
      title = interpolateString(
        cmsData.rentalsByRegionLabel,{
          placeName: country?.name || '',  
           modelOrMakeOrTypeName,   
          })
      linksList = regions.map((region, index) => ({
        id: index,
        path: PATHS.geoSlug([
          vehicle_make?.slug,
          vehicle_type?.slug,
          vehicle_model?.slug,
          region.slug,
        ]),
        lable: getLabel(region),
      }));
    } else {
      title = interpolateString(
          cmsData.rentalsByCityLabel,{
          placeName: country?.name || '', 
          modelOrMakeOrTypeName,
       }); 
      linksList = geographies.map((geography, index) => ({
        id: index,
        path: PATHS.geoSlug([
          vehicle_make?.slug,
          vehicle_type?.slug,
          vehicle_model?.slug,
          geography.slug,
        ]),
        lable: getLabel(geography),
      }));
    }

    return {
      title,
      linksList,
    };
  };
  const nearbyRentalsGroups = useMemo(() => {
    const rentalsGroups = [];
    if (nearbyRentals?.by_countries) {
      rentalsGroups.push(prepareCountriesLinks(nearbyRentals?.by_countries));
    }
    if (nearbyRentals?.by_vehicle_types) {
      rentalsGroups.push(
        prepareVehicleTypeOrMakeLinks(
          nearbyRentals?.by_vehicle_types,
          'vehicle_type',
        ),
      );
    }
    if (nearbyRentals?.by_vehicle_makes) {
      rentalsGroups.push(
        prepareVehicleTypeOrMakeLinks(
          nearbyRentals?.by_vehicle_makes,
          'vehicle_make',
        ),
      );
    }
    if (nearbyRentals?.by_vehicle_models) {
      rentalsGroups.push(
        prepareVehileModelLinks(nearbyRentals?.by_vehicle_models),
      );
    }
    if (nearbyRentals?.by_geographies) {
      rentalsGroups.push(prepareGeographyLinks(nearbyRentals?.by_geographies));
    }
    if (nearbyRentals?.by_regions) {
      rentalsGroups.push(prepareRegionsLinks(nearbyRentals?.by_regions));
    }
    return rentalsGroups;
  }, [nearbyRentals]);

  return (
    <Box>
      {nearbyRentalsGroups.map((rentalsGroup) => (
        <LinksGroupSection
          key={rentalsGroup.title}
          linksGroup={rentalsGroup}
          handleLinkClick={handleNearByLinkClick}
        />
      ))}
     
    </Box>
  )
};

export { NearbyRentalsWrapper };
